import React from 'react'
import '../styles/home.css'

function Home() {
    return(
    <div>

        <div className="home_wrapper page_content">
            <h3>Smart Khalanga Solutions Overview</h3>
            <p>
            Smart Khalanga Solutions Pty Ltd also known as Smart KS is a strategic and
            operational enablement partner to the information technology industry
            providing critical skills, knowhow and resources needed to procure, install,
            connect, monitor and support exceptional IT solutions.
            </p><p>
            <br/>
            Established in 2014, Smart KS has gradually acquired world class skill and
            broadened its service portfolio to cater for a wide range of specialised IT client
            needs. Smart KS make use of astute business analyst to determine client
            requirement, perceptive engineers and diligent project management to deliver
            solutions.
            <br/>
            </p><p>
            Smart KS is registered with leading IT and electrical distributors (Rectron, CH
            Africa, mustek, Tarsus, Axiz, Pinnacle, Westcon, Hi-Q & KH) across the continent
            and is recommended as the best and most trustworthy reseller of professional
            deliverables.
            <br/>
            </p><p>
            The ownership of Smart Khalanga Solutions as a Level 1 BBBEE Contributor is
            fully compliant with Broad-Based Black Economic Empowerment (BBBEE)
            initiatives and structures as contemplated by organizations and forums
            progressing transformation in South Africa.
            <br/>
            </p><p>
            Smart KS is a corporate socially responsible organisation that strongly believes in
            the upliftment of communities using technology.
                        </p>
        </div>
    </div>
    )
}

export default Home;